<ion-content class="ion-padding" color="medium">
  <curbnturf-new-password></curbnturf-new-password>
</ion-content>
